import React, { Fragment, useEffect, useState } from 'react'
import { FaArrowRightLong } from 'react-icons/fa6'
import ProductCard from '../Main/ProductCard'
import product1 from "../../Assets/Images/product1.png";
import product2 from "../../Assets/Images/product2.png";
import product3 from "../../Assets/Images/product3.png";
import { getBooks } from '../../Services/BooksServices';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';

import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


const RelatedBooks = ({ title, background }) => {


    const [booksData, setBooksData] = useState([])
    const [isLoading, setIsLoading] = useState(false)


    const handleGetBooks = async () => {
        setIsLoading(true)
        let response = await getBooks("book")
        if (response.statusCode === 200) {
            setBooksData(response?.response?.data?.data)
            // localStorage.setItem("bookData", JSON.stringify(response?.response?.data?.data));
            // setLinks(response?.response?.data?.links)
            // setTotalProducts(response?.response?.data?.total)
            // setShowingProducts(response?.response?.data?.to)
            setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            // for (const [key, value] of Object.entries(response?.errors)) {
            //     toast?.error(value)
            // }
            toast?.error(response?.errors)

            setIsLoading(false)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        handleGetBooks();
    }, [])


    console.log(booksData)


    return (
        <Fragment>
            <section className={`py-100 ${background ? `bg-${background}` : 'bg-light'}`}>
                <div className="container">

                    <div className="row">
                        <div className="col">
                            <h2 className='heading'>
                                {
                                    title ? title :
                                        "10 Top Rated Books"
                                }
                            </h2>


                        </div>
                        <Link to={"/books"} state={"book"} className="text-dark col-auto s-14">
                            View more
                            {" "}
                            <FaArrowRightLong className='ms-2' />
                        </Link>

                    </div>

                    <div className="row mt-4 justify-content-center">

                        <Swiper
                            // style={{ width: "100%", height: "250px" }}
                            modules={[Navigation, Pagination, Scrollbar, A11y]}
                            spaceBetween={1}
                            slidesPerView={5}
                            navigation
                            breakpoints={{
                                320: {
                                    slidesPerView: 1,
                                },
                                480: {
                                    slidesPerView: 2,
                                },
                                768: {
                                    slidesPerView: 3,
                                },
                                1024: {
                                    slidesPerView: 4,
                                },
                                1200: {
                                    slidesPerView: 6,
                                },
                            }}
                        // pagination={{ clickable: false }}
                        // scrollbar={{ draggable: true }}
                        >

                            {Array.isArray(booksData) && booksData?.length > 0 ? (
                                booksData?.map((item, i) => {
                                    return (
                                        // <div className="col-lg-2">
                                        <>
                                            <SwiperSlide className='container' key={i}>

                                                <ProductCard
                                                    data={item}
                                                    key={i}
                                                />
                                            </SwiperSlide>
                                        </>
                                        // </div>
                                    )
                                })

                            ) : ("No data Found")}
                        </Swiper>
                    </div>
                </div>
            </section>

        </Fragment>
    )
}

export default RelatedBooks